/* Complemento de assets/lah-turbo.js — marca o pedido com a escolha de prazo.

   ============================================================================
   POR QUE UM ATRIBUTO, E NAO UMA TAG
   ============================================================================
   Tag de pedido so pode ser criada por app ou pelo Shopify Flow — o tema nao
   escreve isso. O que o tema alcanca e o ATRIBUTO do carrinho, que vira
   "Detalhes adicionais" no pedido e ja da visibilidade imediata no admin.

   A TAG propriamente dita sai do Flow, com a regra:

     Gatilho .... Pedido criado
     Condicao ... algum item do pedido tem SKU LENTE-RESINA-ENVIOTURBO
     Acao ....... adicionar tag TURBO ao pedido

   Repare que o Flow nao depende deste arquivo: ele le a VARIANTE, que e o
   fato consumado da compra. Se o JS falhar, o atributo some — mas a variante
   comprada nao mente, e a tag continua correta. Duas fontes, e a mais
   confiavel e a que decide.

   ============================================================================
   POR QUE GRAVAMOS SEMPRE, INCLUSIVE "COMUM"
   ============================================================================
   Se so gravassemos ao escolher Turbo, um cliente que escolhesse Turbo,
   voltasse e trocasse para comum ficaria com o atributo antigo no carrinho —
   e o pedido sairia marcado como Turbo sem ter sido. Gravar os dois estados
   mantem o atributo sempre igual a escolha atual.
   ============================================================================ */

(function () {
    'use strict';

    var tela = document.querySelector('[data-lah-turbo]');
    if (!tela) return;

    function gravar(valor) {
        var atributos = { 'Envio': valor };

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: atributos })
        }).catch(function () {
            /* Falhou: a compra segue normalmente. A tag do Flow nao depende
               disto — ela le a variante comprada. */
        });
    }

    tela.addEventListener('click', function (event) {
        if (!event.target.closest('[data-turbo-continuar]')) return;

        var turbo = tela.getAttribute('data-turbo-escolha') === 'turbo';
        gravar(turbo ? 'TURBO' : 'COMUM');
    });
})();
